/**
 * Privacy Policy
 */

import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";
import { createFileRoute, Link } from "@tanstack/react-router";

export const Route = createFileRoute("/_public/privacy-policy")({
  component: TermsOfUse,
});

function TermsOfUse() {
  return (
    <div>
      <title>Privacy Policy - Legrande Health Portal</title>
      <Card>
        <CardHeader>
          <div className="flex justify-center gap-4">
            <CardTitle>
              <Link to="/terms-of-use">Terms of Use</Link>
            </CardTitle>
            <Separator orientation="vertical" className="h-6!" />
            <CardTitle>
              <Link className="text-primary underline" to="/privacy-policy">
                Privacy Policy
              </Link>
            </CardTitle>
          </div>
        </CardHeader>
        <CardContent>
          <p>
            Legrande Corporation ("Legrande", "we" or "us") is committed to
            respecting the privacy and security of your personal information. We
            work with your doctors, dispensaries, and pharmacies to help you get
            doctor-prescribed medications at a great price. In connection with
            that, we collect information when you access or use our Site or
            Services. The following online privacy policy ("Privacy Policy")
            describes the information we collect and how we use that
            information. By using this website ("Site") or the service offered
            through our Site, including without limitation any mobile
            applications (collectively, the "Service"), you consent to our
            Privacy Policy. This Privacy Policy deals with how Legrande
            collects, uses, and shares information. We may periodically update
            this Privacy Policy to reflect material changes in how we collect,
            use, share or store your personal information. We encourage you to
            refer to this Privacy Policy on an ongoing basis so that you
            understand our current Privacy Policy. You consent to any changes we
            make to this Privacy Policy if you continue to use the Site or
            Service after receiving a notice of the change or upon our posting
            of the new Privacy Policy on this Site. This Privacy Policy informs
            you about:
          </p>
          <ol className="list-decimal flex flex-col gap-4 ml-4 my-4">
            <li className="ml-8">
              the personal information we collect and how we collect it;
            </li>
            <li className="ml-8">
              how we use and disclose the personal information;
            </li>
            <li className="ml-8">how we protect your personal information;</li>
            <li className="ml-8">
              our practices regarding the information of children;
            </li>
            <li className="ml-8">third party data practices; </li>
            <li className="ml-8">
              how you can access and change the personal information we store
              about you; and
            </li>
            <li className="ml-8">
              how you can contact us with any questions or concerns.
            </li>
          </ol>
          <p className="my-4">
            As used in this Privacy Policy, the term "personal information" is
            information that would allow someone to identify or contact you,
            including, for example, your full name, address, telephone number,
            birth date, or email address. Non-personal information is
            information that does not directly identify an individual. We
            collect both types of information about you. The following provides
            examples of the types of data that we collect from you and how we
            use the information.
          </p>
          <p>
            <b>COLLECTING INFORMATION: </b>
          </p>
          <p>
            The following are the types of information we collect: Information
            you give us: We receive the personal information you provide to us
            when you use the Site such as your answers to any questions you
            provide. If you provide information directly to us in other ways,
            such as by sending us an email, we may retain that information and
            add it with the other information we have collected from you. We may
            also collect personal information that is necessary for our
            legitimate interests, which will be disclosed to you at the time of
            collection. We will use this information for the purposes of which
            it was collected. We collect information from you, such as your
            first and last name, gender, e-mail, billing and mailing addresses,
            phone number, company name, title, website urls, and password when
            you create an account to log in to our network. If you elect to use
            our prescription delivery services, we and our third party partners
            will collect the full name of the patient, phone number, current
            prescription number, photo of insurance card (if applicable), credit
            card information and postal address. We may also collect certain
            medical information such as your physician's and current pharmacy or
            dispensary names, phone numbers and addresses, information about the
            prescription medication, and medical history such as allergies. We
            also retain information that you post or store through your account
            and/or on our website, including without limitation any messages you
            send or post, and your interests and preferences. If you purchase
            anything through our site, we (or our third party partners) may
            collect your credit card or payment information. You may choose not
            to provide all or a portion of this information, however creating an
            account is a prerequisite for using the full functions of the Site.
            We may also collect personal information that is necessary for our
            legitimate interests, which will be disclosed to you at the time of
            collection. We will use this information for the purposes of which
            it was collected Information from your doctors, dispensaries, or
            pharmacies. We may receive information about you from your doctors,
            dispensaries, or pharmacies, including Participating Dispensaries as
            defined in our terms of use. All of your protected health
            information maintained by us, including information you provide
            through the Site or Service, is also subject to the Notices of
            Privacy Practices issued by your doctor or pharmacy under the Health
            Insurance Portability and Accountability Act, as amended ("HIPAA").
            The Notices of Privacy Practices may contain additional provisions
            relating to the use and disclosure of your information that go
            beyond the terms of this Privacy Policy. To the extent there is any
            conflict between this privacy policy and our applicable obligations
            under HIPAA, we will comply with comply with our obligations under
            HIPAA. Information from other third parties: We may receive personal
            information about you from other sources, such as our business
            partners or from individuals who refer you to us. We may also
            receive information about you from third parties, including
            marketers and advertisers. We may add this information to other
            information we collect from you. If your employer or a company with
            which you are affiliated is a member, we may receive information
            about you from your employer or such entity, including your name,
            title, email, and contact information. Automatically collected
            information: We may receive and store certain types of information
            from you each time you use the Site or Service. For example we may
            automatically log your browser type, language preference, the date
            and time of your visit to the Site, your time zone, your Internet
            Protocol (IP) address, and the website you visited before our Site.
            In addition, we may receive and store information about your use of
            the Site and Service, including, for example, the pages you visited,
            the length of your session, the purchases you made, and the
            applications you downloaded. We may also receive and store
            information about the device you used to access the Site and
            Service, including, for example, the device's make, the device's
            model, the device's operating system, your carrier, and any mobile
            applications through which you interact with the Site and Services.
            The technologies we use for this automatic data collection may
            include:
          </p>
          <ul className="list-disc my-4 flex flex-col gap-2">
            <li className="ml-8">
              <b>Cookies.</b>
              <p>
                Cookies are small data files stored on your hard drive by a
                website. Among other things, cookies help us improve our Site
                and Service and improve your experience on our Site and within
                our Service by analyzing the way you use our Site and Service.
                You can set your browser to not accept cookies, but that may
                prevent us from providing you with the full range of Service we
                offer. Also, please be aware that if you visit other websites
                you may be required to accept cookies. The use of cookies placed
                by third parties on other websites is not covered by this
                Privacy Policy. We do not have access or control over such
                cookies.
              </p>
            </li>
            <li className="ml-8">
              <b>Web Beacons.</b>
              <p>
                Web beacons are electronic images that may be used on our Site
                or in our emails. We use web beacons to deliver cookies, count
                visits, understand usage and campaign effectiveness and to tell
                if an email has been opened and acted upon.
              </p>
            </li>
            <li className="ml-8">
              <b>Other.</b>
              <p>
                We may also use clear gifs or other data files or identifiers to
                collect information for statistical purposes and to improve and
                develop the Service we provide. Clear gifs are tiny graphics
                with a unique identifier, similar in function to cookies. In
                contrast to cookies, which are placed on a hard drive, clear
                gifs are embedded invisibly on web pages. We use Google Tag
                manager to cache images on your device for faster loading
                speeds. We also use Google and Facebook conversion pixels to
                gain visibility into the success of our advertising.
              </p>
            </li>
            <li className="ml-8">
              <b>Location Information.</b>
              <p>
                When you use our mobile application, we may collect and store
                information about your location by accessing your mobile
                device's GPS coordinates to determine a rough location if you
                enable location services on your device. We may use location
                information to improve and personalize our Services for you. If
                you do not want us to collect location information, you may
                disable that feature on your mobile device.
              </p>
            </li>
          </ul>
          <p className="my-4">
            We also may use these technologies to collect information about your
            online activities over time and across third-party websites or other
            online services (behavioral tracking). We do not respond to
            browser-based "do not track" signals. Some third party sites who
            push content to our Site may keep track of your browsing activities
            over time and across different websites when they serve you content,
            which enables them to tailor what they present to you.
          </p>
          <p className="my-4">
            We use session monitoring and analytics tools to better understand
            how users interact with our Site and Services. These tools help us
            analyze user behavior, improve functionality, and enhance user
            experience by collecting data such as: Session recordings (e.g.,
            clicks, scrolling, navigation paths) Event tracking (e.g., feature
            usage, button clicks, form interactions) Device and browser
            information (e.g., IP address, operating system, browser type) The
            data collected is aggregated and anonymized where possible, and it
            is used solely for internal analytical purposes. We do not use this
            information to identify individual users unless required for
            security or fraud prevention.
          </p>
          <p>
            <b>USING AND DISCLOSING INFORMATION</b>
          </p>
          <p>
            We use and disclose your personal information only as described in
            this Privacy Policy or as otherwise disclosed to you on our Site.
            For example, subject to applicable law, we may use and/or disclose
            your personal information:
          </p>
          <ul className="list-disc my-4 flex flex-col gap-2">
            <li className="ml-8">
              <p>
                To provide you with the Services. As part of this, in order to
                fulfill your order and deliver your prescription, we will use
                and transfer certain information to one or more of your doctors
                and to one or more dispensaries and/or pharmacies (including
                Participating Dispensaries), as well as your insurance company.
                If the pharmacy or dispensary initially chosen by the Services
                is unable to fill your prescription, we may transfer your
                personal information to another dispensary or pharmacy that will
                process and fill your prescription.
              </p>
            </li>
            <li className="ml-8">
              To otherwise operate and improve our Site and Services;
            </li>
            <li className="ml-8">
              To confirm that you are an actual person and not a bot;
            </li>
            <li className="ml-8">
              To facilitate the creation of and secure your account on our
              network and identify you as a user in our system;
            </li>
            <li className="ml-8">
              To respond to any questions or concerns that you may have;
            </li>
            <li className="ml-8">
              To send you marketing, promotional communications, upgrades and
              special offers related to our services and for other marketing
              purposes of ours or our third party companies;
            </li>
            <li className="ml-8">
              For market research, analytical purposes, project planning, and
              product development;
            </li>
            <li className="ml-8">
              For troubleshooting problems, detecting and protecting against
              errors, fraud, or other criminal activity;
            </li>
            <li className="ml-8">
              To better understand your needs and provide you with more
              personalized Services;{" "}
            </li>
            <li className="ml-8">
              To fulfil other legitimate purposes permitted by applicable law;
            </li>
            <li className="ml-8">
              To third-party contractors that provide services to us and are
              contractually bound to safeguard your personal information (i.e.,
              website hosting providers, payment processors, log monitoring
              analysts, forensic data scientists, user data analysts, marketing
              assistants, and other service providers for legitimate purposes
              permitted by applicable law);
            </li>
            <li className="ml-8">
              To insurance companies and their contractors;
            </li>
            <li className="ml-8">
              To the manufacturer(s) and distributor(s) of the products you
              order through us;
            </li>
            <li className="ml-8">
              To other third parties, including any product or advice
              manufacturers, for their own marketing, research, and promotional
              purposes;
            </li>
            <li className="ml-8">
              To our wholly-owned companies and affiliates (including without
              limitation any affiliated non-profit organizations), which may be
              outside the United States;
            </li>
            <li className="ml-8">
              To third parties in connection with any merger, acquisition,
              reorganization, change in capital structure or sale of all or part
              of the business or makes a sale or transfer of assets of Legrande;
            </li>
            <li className="ml-8">
              To third parties designated by you with your express consent;
            </li>
            <li className="ml-8">
              as described in our (or your doctor's or pharmacy's) Notices of
              Privacy Practices for protected health information;
            </li>
            <li className="ml-8">
              When we have a good faith belief that disclosure is necessary to
              comply with law, protect or defend our rights or the rights of
              other users of our Site or products or Services, or act in an
              emergency to protect someone's safety; or
            </li>
            <li className="ml-8">Otherwise with your express consent</li>
          </ul>
          <p className="my-4">
            We may create non-personally identifying anonymous or aggregate data
            from the information we collect and information provided by third
            parties. We may use that anonymous or aggregate data for our own
            purposes or disclose it to third parties in our own discretion.{" "}
          </p>
          <p>
            <b>PROTECTING YOUR INFORMATION </b>
          </p>
          <p>
            We take reasonable steps to help protect your personal information
            in an effort designed to prevent loss, misuse, unauthorized access,
            disclosure, alteration and destruction. We follow reasonable
            standards to protect the personal information submitted to us, both
            during transmission and once we receive it. However, no method of
            transmission over the Internet, or method of electronic storage is
            100% secure. ACCORDINGLY, WE CANNOT AND DO NOT GUARANTEE THAT YOUR
            INFORMATION IS COMPLETELY SECURE AND SAFE FROM SUCH RISKS OR THAT IT
            WILL BE SECURE TRANSMITTED OVER THE INTERNET. FOR THE AVOIDANCE OF
            DOUBT, WE EXPRESSLY DISCLAIM ANY REPRESENTATION OR WARRANTY, WHETHER
            EXPRESS OR IMPLIED, WITH RESPECT TO ENSURING, GUARANTEEING OR
            OTHERWISE OFFERING ANY DEFINITIVE PROMISE OF SECURITY IN CONNECTION
            WITH YOUR INFORMATION. Please contact us if you have any questions
            about security of our Site.
          </p>
          <p className="mt-4">
            <b>PROCEDURES REGARDING CHILDREN</b>
          </p>
          <p>
            Our Site and Service is not intended for children under 13 years of
            age. No one under age 13 may provide any information to us using the
            Site or Service.
          </p>
          <p className="mt-4">
            <b>THIRD PARTIES </b>
          </p>
          <p>
            Advertisements and Links to Other Websites: The Site may contain
            links, content, and advertisements from third parties. Such links,
            content, and advertisements are not endorsements, authorizations or
            representations of our affiliation with that third party. We are not
            responsible for the privacy practices or the content of third
            parties, and we encourage you to carefully review the privacy policy
            of any website you visit. Legrande expressly disclaims, any and all
            liability related to actions of such linked Sites, their terms and
            conditions and/or the content of such sites. Advertising agencies,
            advertising networks, and other companies who may place
            advertisements on our Site may use their own cookies, pixel tags,
            web beacons, web bugs and other technology to collect information
            about you.We do not control these companies' use of such technology
            and we have no responsibility for the use of such technology by
            these companies to gather information about you.
          </p>
          <p className="mt-4">
            <b>HOW TO REVIEW, MODIFY OR DELETE YOUR INFORMATION</b>
          </p>
          <p>
            We want to communicate with you only if you want to hear from us. If
            you prefer not to receive information from us or would like to
            update or change your personal information or preferences, follow
            the instructions below to review, modify or delete your personal
            information.
          </p>

          <ul className="list-disc my-4 flex flex-col gap-2">
            <li className="ml-8">
              <p>
                To modify the information you have provided during registration,
                please login and update your personal settings on the Site.
              </p>
            </li>
            <li className="ml-8">
              <p>
                To unsubscribe from a promotional email, please follow the
                instructions in any email you receive. If you decide not to
                receive promotional emails, we may still send you transactional
                communications, such as those about your account, to fulfill
                orders you have made, to ask you to rate a product you
                purchased, or event you attended.
              </p>
            </li>
            <li className="ml-8">
              <p>
                If you have submitted information through the Site, and you
                would like to review, request changes or have that information
                deleted from our databases, please contact us by email at{" "}
                <a
                  className="text-primary"
                  href={`mailto:support@legrandehealth.com`}
                >
                  support@legrandehealth.com.
                </a>
              </p>
            </li>
          </ul>

          <p>
            If you request your registration information be deleted or if you
            unsubscribe from communications, we may need to retain certain
            information for record keeping purposes, as required under
            applicable legal obligations, or to complete any transactions that
            you began prior to requesting such change or access. Notwithstanding
            the prior two sentences, if the laws in your state provide you with
            additional protections, or require us to comply with more stringent
            obligations to provide you with, remove, or correct your personally
            identifiable information, we will comply with such legal
            requirements. When updating or deleting your personal information,
            we may ask you to verify your identity before we can act on your
            request. We will comply with your request as soon as reasonably
            practicable and in accordance with applicable. Our Site offers
            publicly accessible community services such as blogs and forums. You
            should be aware that any information you provide in these areas may
            be read, collected, and used by others who access them. Your posts
            may remain even after you cancel your account.
          </p>

          <p className="mt-4">
            <b>RETENTION OF PERSONAL INFORMATION</b>
          </p>

          <p>Legrande retains your personal information:</p>
          <ul className="list-disc my-4 flex flex-col gap-2">
            <li className="ml-8">
              <p>
                For so long as your account is active or as needed to provide
                you with Services or to fulfill our contractual
                obligations;{" "}
              </p>
            </li>
            <li className="ml-8">
              <p>
                As necessary to comply with our legal obligations, resolve
                disputes, and enforce our agreements; and
              </p>
            </li>
            <li className="ml-8">
              <p>
                For so long as is necessary for the purposes for which we
                collected such personal information.
              </p>
            </li>
          </ul>
          <p>
            <b>QUESTIONS AND FEEDBACK</b>
            <br /> We welcome your questions, comments, and concerns about
            privacy.Please contact us by email at{" "}
            <a
              className="text-primary"
              href={`mailto:support@legrandehealth.com`}
            >
              support@legrandehealth.com.
            </a>{" "}
            If Legrande needs, or is required, to contact you concerning any
            event that involves information about you, we may do so by email,
            telephone, or mail.
          </p>
          <p className="mt-4">
            <b>COMPLAINTS</b>
          </p>
          <p>
            If you have a data privacy complaint, please contact us at
            support@legrandehealth.com. We are committed to working with you to
            obtain a fair resolution of any privacy concern.{" "}
          </p>
          <p className="mt-4">
            <b>CALIFORNIA AND EUROPEAN ECONOMIC AREA VISITORS</b>
          </p>
          <p>
            Residents of the State of California may request a list of all third
            parties to which Legrande has disclosed certain information
            collected in connection with this Site and Service during the
            preceding year for the third parties' direct marketing purposes. If
            you are a California resident and want such a list, please contact
            us at support@legrandehealth.com. For all requests, you must put the
            statement "Your California Privacy Rights" in the body of your
            request and include the name of this Site, as well as your name,
            street address, city, state, and zip code. Please note that we will
            not accept requests via the telephone, mail, or by facsimile, and we
            are not responsible for notices that are not labeled or sent
            properly, or that do not have complete information. In accordance
            with applicable laws, you may have the right to request access to,
            rectification, and erasure of your personal information; restriction
            of processing of personal information; objecting to certain
            processing of personal information; and the right to data
            portability. Where any processing of personal information is solely
            dependent upon your consent, you have the right to withdraw such
            consent at any time (For example, we suggest by using the
            unsubscribe link contained in an applicable marketing message or
            emailing us at support@legrandehealth.com). Where you believe that
            we have not processed your personal information in accordance with
            applicable laws, you may lodge a complaint with the respective
            supervisory authority or data protection regulator. The provision of
            personal information by you will be for contractual, marketing,
            analytical purposes, or other purposes as referred to in this
            Privacy Policy. When we receive your request, we may ask you to
            verify your identity before we can act on your request. We may
            withhold information where we are required by law to do so or if the
            search for that information would require disproportionate effort or
            have a disproportionate effect to, for example, the cost of
            providing the information, the time it would take to retrieve the
            data, or how difficult it may be to obtain the information
            requested.
          </p>
          <p className="mt-4">
            <b>INTERNATIONAL OPERATIONS</b>
          </p>
          <p>
            Legrande is based, and this Site is hosted, in the United States of
            America. If you are from a country outside of the United States of
            America with laws governing data collection, use, and disclosure
            that may differ from U.S. law and you provide personal information
            to us, please note that any personal information that you provide to
            us may be transferred to the United States of America. By providing
            your personal information, you hereby specifically and expressly
            consent to such transfer and processing and the collection, use, and
            disclosure set forth herein.
          </p>
          <p className="mt-4">
            <b> EMAILS AND SMS TEXT MESSAGING</b>
          </p>
          <p>
            Legrande uses a third-party vendor to help us manage some of our
            email and text messaging communications with you. While we do supply
            these vendors with email addresses or mobile telephone numbers of
            those we wish them to contact, your email address or mobile
            telephone number is never used by them for any purpose other than to
            communicate with you on our behalf. Even if you have given us
            permission to send emails or text messages to you, you may revoke
            that permission at any time by following the ‘unsubscribe'
            information at the bottom of the email or by replying "Stop" to any
            text message you receive from us. It is your responsibility for
            obtaining the data network access and mobile device necessary to use
            the Services. Your mobile network's data and messaging rates and
            fees may apply if you access or use the Services from your device.
          </p>
          <p className="my-4">
            <b>NOTE:</b>IF YOU ARE NOT A CALIFORNIA CONSUMER, THIS NOTICE DOES
            NOT APPLY TO YOU. Instead please refer to our general Privacy
            Policy.
          </p>
          <p className="my-4">
            <b>California Privacy Notice:</b>
          </p>
          <p className="my-4">
            <b>Effective Date: January 30, 2020</b>
          </p>
          <p className="my-4">
            The California Consumer Privacy Act of 2018 (CCPA) gives certain
            consumers that reside in California ("California Consumers") the
            right to know what categories of personal information Legrande
            Corporation ("Legrande", "we" or "us") collects about them, and how
            that personal information is collected, used and shared. This
            California Privacy Notice ("Privacy Notice") provides the
            information required under the CCPA and applies to both Legrande's
            online and offline activities relating to California Consumers'
            Personal Information. This Privacy Notice supplements Legrande's
            general Privacy Policy.
          </p>
          <p className="my-4">
            We may periodically update this Privacy Notice to reflect material
            changes in how we collect, use, share or store your personal
            information. We encourage you to refer to this Privacy Notice on an
            ongoing basis so that you understand our current Privacy Notice. You
            consent to any changes we make to this Privacy Notice if you
            continue to use the Site or Service after receiving a notice of the
            change or upon our posting of the new Privacy Notice on this Site.
          </p>
          <p className="my-4">
            As used in this Privacy Notice, the term "Personal Information" is
            information that identifies, relates to, describes, is capable of
            being associated with, or could reasonable be linked, directly or
            indirectly, with a particular California resident or household,
            including: 1) Personal identifiers, such as a real name, alias,
            postal address, unique personal identifier, IP address, email
            address, account name, social security number, driver's license
            number, passport number, or other similar identifiers; 2) Commercial
            information, including records of personal property, products or
            services purchased, obtained, or considered, or other purchasing or
            consuming histories or tendencies; 3) Internet or other electronic
            network activity information, including, but not limited to,
            browsing history, search history, and information regarding a
            California resident's interaction with an internet web site,
            application, or advertisement; 4) Geolocation data; 5) Biometric
            information; 6) Audio, electronic, visual, thermal, olfactory, or
            similar information; 7) Professional or employment-related
            information; 8) Education information; and 9) Inferences about
            personal preferences and attributes drawn from profiling (e.g. via
            cookies).
          </p>
          <p className="mt-4">
            <b>Your Rights Under the CCPA:</b>
          </p>
          <p className="my-4">
            If you are a California Consumer you have certain rights with
            respect to Legrande's use and disclosure of your Personal
            Information:
          </p>
          <p className="my-4">
            Right of Access: You have the right to request from us the
            categories of Personal Information we have collected about you, the
            categories of sources from which the Personal Information is
            collected, the business purpose or commercial purpose for collecting
            the Personal Information, the categories of third parties with whom
            we share Personal Information, and the categories of Personal
            Information we have shared and the reasons we shared it. You also
            have the right to request from us a copy of the specific pieces of
            Personal Information we have collected about you in the preceding 12
            months.
          </p>
          <p className="my-4">
            Right to Deletion: You have the right to request the deletion of
            Personal Information that we hold on you. However, this right does
            not apply where we need to retain the Personal Information in order
            to do any of the following: Provide goods or services to you, detect
            or resolve issues security or functionality-related issues, comply
            with the law, conduct research in the public interest, safeguard the
            right to free speech, or carry out any actions for internal purposes
            that you might reasonably expect.
          </p>
          <p className="my-4">
            Non-Discrimination: We will not discriminate against you for
            exercising any of your CCPA rights. Unless permitted by the CCPA, we
            will not: Deny you goods or services, charge you different prices or
            rates for goods or services, provide you a different level or
            quality of goods or services, nor suggest that you may receive a
            different price or rate for goods or services or a different level
            or quality of goods or services. However, in some circumstances, for
            example where you have requested or consented to our services that
            use your Personal Information to provide the service, we may not be
            able to provide a service if you choose to delete your Personal
            Information. To submit your request to exercise your CCPA rights,
            you may contact us at{" "}
            <b>(855) 498-1272 or by e-mail at support@legrandehealth.com</b>. We
            will then use the information you submit in your request to match
            the information we have in our system to verify your identity. Only
            you, or a person registered with the California Secretary of State
            that you authorize to act on your behalf, may make a request related
            to your Personal Information. You may also make a request on behalf
            of your minor child. Your request must be described with sufficient
            detail that allows us to properly understand, evaluate and respond
            to it. We cannot respond to your request or provide you with
            Personal Information if we cannot verify your identity or authority
            to make the request and confirm the Personal Information relates to
            you. <b>Personal Information collected, used and shared:</b>
          </p>
          <p className="my-4">
            If you are a California Consumer, the details on what Personal
            Information we collect, use and share about you can be found here:
            https://legrandehealth.com/
          </p>
          <p className="my">
            <b>Sold Information:</b>
          </p>
          <p className="my-4">
            Legrande does not sell Personal Information of California Consumers.
            Should this change, this Privacy Notice will be updated.
          </p>
          <p className="my">
            <b>Questions and Feedback: </b>
          </p>
          <p className="my-4">
            We welcome your questions, comments, and concerns about privacy.
            Please contact us by email at{" "}
            <a
              className="text-primary"
              href={`mailto:support@legrandehealth.com`}
            >
              support@legrandehealth.com.
            </a>
            . If Legrande needs, or is required, to contact you concerning any
            event that involves information about you, we may do so by email,
            telephone, or mail.
          </p>
          <p className="my">
            <b>Complaints: </b>
          </p>
          <p className="my-4">
            If you have a data privacy complaint, please contact us at
            support@legrandehealth.com. We are committed to working with you to
            obtain a fair resolution of any privacy concern.{" "}
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
